export const questionsData = [
    {
      quizId: 'clodomiro',
      id: 1,
      goto: "/dashboard",
      header: "Con base en el contenido de su laboratorio, ¿cómo aprovechó Clodomiro Picado la creación de sueros antiofídicos para beneficiar a la sociedad?.",
      options:  [
        {
          id: 1,
          text: "Creando una lista de las serpientes venenosas de Costa Rica y sus sueros correspondientes",
          correct: true
        },
        {
          id: 2,
          text: "Importando sueros antiofídicos hechos a la medida",
          correct: false
        },
        {
          id: 3,
          text: "Asegurando que todos los dueños de fincas tuvieran suero antiofídico a mano para proteger a sus trabajadores",
          correct: true
        },
        {
          id: 4,
          text: "Inventando la penicilina",
          correct: true
        }
      ]
    }
  ];